import ComcastCode from "./ComcastCode";
import { getModel } from "../../utils/models";

const SalesInfo = () => {
    const model = getModel();
    switch (model) {
        case "xumo":
            return (
                <div className="spectrum-sales-container">
                    <div className="horizontal-separator"></div>

                    <div className="spectrum-sales-text">
                        <div className="spectrum-sales-text-content">Interested in purchasing DAZN For Business?</div>
                        <div className="spectrum-sales-text-content">Call Spectrum Business at <span className="spectrum-phone">{process.env.REACT_APP_SPECTRUM_SALES_NUMBER}</span>
                        </div>
                    </div>
                </div>
            );
        case "xi6":
        case "xid":
        case "xg2v2":
            return (
                <div className="spectrum-sales-container">
                    <div className="horizontal-separator"></div>
                    <div className="spectrum-sales-text">
                        <div className="spectrum-sales-text-content">Interested in purchasing DAZN For Business?
                        Call DAZN For Business at <span className="spectrum-phone">{process.env.REACT_APP_COMCAST_SALES_NUMBER}</span>
                        </div>
                    </div>
                    <ComcastCode />
                </div>
            );
        default: 
            return (<></>);
    }
};

export default SalesInfo;